import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Login from "../pages/Auth/Login/Login";
import PrivateRoutes from "./PrivateRoutes";
import Dashboard from "../pages/App/Dashboard/Dashboard";
import Products from "../pages/App/Products/Products";
import Categories from "../pages/App/Categories/Categories";
import Orders from "../pages/App/Orders/Orders";
import Users from "../pages/App/Users/Users";
import SidebarLayout from "./SidebarLayout";
import PrivacyPolicy from "../pages/Auth/PrivacyPolicy/PrivacyPolicy";
import DeleteAccount from "../pages/Auth/DeleteAccount/DeleteAccount";
const AppRoutes = () => {
  return (
    <div>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/delete-account" element={<DeleteAccount />} />
          <Route path="/" element={<PrivateRoutes />}>
            <Route element={<SidebarLayout />}>
              <Route path="/" element={<Dashboard />} />
              <Route path="/products" element={<Products />} />
              <Route path="/categories" element={<Categories />} />
              <Route path="/orders" element={<Orders />} />
              <Route path="/users" element={<Users />} />
            </Route>
          </Route>
        </Routes>
      </Router>
    </div>
  );
};

export default AppRoutes;
